import React from 'react';
import GlobalMeta from '../../reusable/GlobalMeta';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import IntroCarousel from '../../reusable/fieldGroups/IntroCarousel';
import InfoCarousel from '../../reusable/fieldGroups/InfoCarousel';
import IntroText from '../../reusable/fieldGroups/IntroText';
import Tickers from '../../reusable/fieldGroups/Tickers';
import ImageBGSection from '../../reusable/fieldGroups/ImageBGSection';
import RandomTestimonial from '../../reusable/RandomTestimonial';
import PartnersCarousel from '../../reusable/PartnersCarousel';
import LatestInsights from '../../reusable/LatestInsights';
import Accreditations from '../../reusable/fieldGroups/Accreditations';
import HomeCarousel from './HomeCarousel';

const Home = () => {

  //get page
  const { data : homepage, isInitialLoading } = useQuery({
    queryKey: ['home'],
    queryFn: () => axios({
      method: 'get',
      url: `${WP_API_Settings.endpoint}wp/v2/pages?slug=home&_embed=true&acf_format=standard`,
    })
  })

  return(
    <>
    	<GlobalMeta />
		<HomeCarousel slides={homepage?.data?.[0].acf.slide}/>
		{/* <IntroCarousel slides={homepage?.data?.[0].acf.slide} loading={isInitialLoading} /> */}
		<IntroText content={homepage?.data?.[0].acf.intro_text} loading={isInitialLoading} />
		<InfoCarousel slides={homepage?.data?.[0].acf.slides} loading={isInitialLoading} />
		<Tickers figures={homepage?.data?.[0].acf.tickers} loading={isInitialLoading} />
		<RandomTestimonial testimonials={homepage?.data?.[0].acf.testimonials} loading={isInitialLoading} />
		<PartnersCarousel loading={isInitialLoading} />
		<ImageBGSection content={homepage?.data?.[0].acf.image_background} loading={isInitialLoading} />
		<LatestInsights loading={isInitialLoading} />
		<Accreditations accreditations={homepage?.data?.[0].acf.accreditations} loading={isInitialLoading} page={'home'} />
    </>
  );
};

export default Home;
